const parseValue = value => {
  const trimmedValue = value.trim();

  if ((trimmedValue.startsWith('"') && trimmedValue.endsWith('"'))
    || (trimmedValue.startsWith("'") && trimmedValue.endsWith("'"))) {
    return trimmedValue.slice(1, -1);
  }

  if (trimmedValue === 'true') return true;
  if (trimmedValue === 'false') return false;

  if (trimmedValue.startsWith('[') && trimmedValue.endsWith(']')) {
    try {
      return JSON.parse(trimmedValue);
    } catch (error) {
      return trimmedValue;
    }
  }

  return trimmedValue;
};

export const parseFrontmatter = source => {
  const match = source.match(/^---\s*\r?\n([\s\S]*?)\r?\n---\s*(?:\r?\n|$)/);

  if (!match) {
    return { data: {}, content: source };
  }

  const data = {};
  match[1].split(/\r?\n/).forEach(line => {
    const separator = line.indexOf(':');
    if (separator === -1) return;

    const key = line.slice(0, separator).trim();
    const value = line.slice(separator + 1);
    if (key) data[key] = parseValue(value);
  });

  return {
    data,
    content: source.slice(match[0].length),
  };
};
